module.exports = __webpack_public_path__ + "static/media/404-error.a8cd6410.svg";